<div class="background-container">
  <div class="login-container">
    <awair-login-form [isLoggingIn]="isLoggingIn$ | async"
                      [isLoggedIn]="isLoggedIn$ | async"
                      [errorMessage]="errorMessage$ | async"
                      (submitForm)="login($event)">
    </awair-login-form>
  </div>
</div>

<awair-footer></awair-footer>
